/**
 * A FIRM'S WRITTEN INSTRUCTION, as Cova staff record it when they act for the
 * firm (decision 059; Tai, 2026-11-03): whose instruction it is, a person at
 * the firm, and where it is. Every staff door that writes on a firm's
 * instruction takes these two fields, spread flat into its payload, so the
 * amend, the instructed archive, the onboarding agree and the write
 * permission read one shape (build plan 2026-11-03-002 §3).
 *
 * It names a person at the firm, never the staff member, who is on the staff
 * trail only. Never logged: the reference can carry a person's name.
 *
 * BROWSER-SAFE: `effect` only.
 */
import { Schema as S } from "effect"

/** The longest name of the person whose instruction it is. */
export const INSTRUCTED_BY_MAX = 120

/** The longest reference to the instruction. */
export const INSTRUCTION_REFERENCE_MAX = 200

export const WrittenInstruction = S.Struct({
  /** The person at the firm whose written instruction this is. */
  instructedBy: S.Trim.pipe(S.minLength(1), S.maxLength(INSTRUCTED_BY_MAX)),
  /** Where the instruction is, for example "The firm's email, 3 Nov 2026". */
  reference: S.Trim.pipe(S.minLength(1), S.maxLength(INSTRUCTION_REFERENCE_MAX)),
}).annotations({ identifier: "BmsWrittenInstruction" })
export type WrittenInstruction = typeof WrittenInstruction.Type
